import { clientMount } from '@vp/ubik-fragment-react'
import type { MountWithRootOptions } from '@vp/ubik-fragment-types'
import { SocialCurations, type Props } from '../components/SocialCurations'

export const mount: MountWithRootOptions<Props> = async (rootElement, renderProps, rootOptions) => {
  return clientMount(<SocialCurations {...renderProps} />, rootElement, rootOptions)
}
